import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
  useMediaQuery,
  Fade,
  Button,
  Grid,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import { ExpandMore } from '@mui/icons-material';
import { addCommas } from '../../../components/converter/index';

const DetailModal = ({
  openDetail,
  setOpenDetail,
  selectedData,
  missionNo,
  data,
}) => {
  const [expanded, setExpanded] = useState(-1);
  const isSmallerThan290 = useMediaQuery('(max-width:290px)');

  return (
    <React.Fragment>
      <Dialog
        onClose={() => setOpenDetail(false)}
        aria-labelledby="customized-dialog-title"
        open={openDetail}
        maxWidth="sm"
        fullWidth={true}
        fullScreen={true}
      >
        <DialogTitle sx={{ m: 0, p: 3 }} id="customized-dialog-title">
          <Typography
            color={'text.primary'}
            variant="h6"
            justifyContent="flex-start"
            textAlign={'left'}
            mt="-8px"
          >
            {data?.items?.length > 0 &&
              data?.items[missionNo]?.parcels[missionNo - 1]?.status}
            ماموریت {missionNo}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => setOpenDetail(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 1,
              p: 2,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ pt: '0px' }}>
          <Card
            sx={{
              boxShadow: 'none',
              border: 0,
            }}
          >
            <CardContent>
              <Stack width={'100%'}>
                <Typography
                  color={'text.primary'}
                  variant="subtitle1"
                  justifyContent="flex-start"
                  textAlign={'left'}
                  fontWeight={'bold'}
                >
                  فرستنده
                </Typography>
                <Typography
                  color={'text.primary'}
                  variant="subtitle2"
                  justifyContent="flex-start"
                  textAlign={'left'}
                  width={'100%'}
                >
                  {selectedData?.[0]?.from?.location?.address
                    ? `${selectedData[0].from.location.address} - ${
                        selectedData[0].from.contact?.first_name ?? ''
                      } ${selectedData[0].from.contact?.last_name ?? ''}`
                    : '-'}
                </Typography>
              </Stack>
            </CardContent>
          </Card>
          {selectedData?.map((item, index) => {
            return (
              <Grid
                mt={2}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
              >
                <Accordion
                  expanded={expanded === index}
                  onChange={() =>
                    setExpanded(expanded === index ? null : index)
                  }
                  slots={{ transition: Fade }}
                  slotProps={{ transition: { timeout: 400 } }}
                  sx={{
                    '& .MuiAccordion-region': {
                      height: expanded === index ? 'auto' : 0,
                    },
                    '& .MuiAccordionDetails-root': {
                      display: expanded === index ? 'block' : 'none',
                      padding: 0,
                    },
                    '& .MuiAccordionSummary-root': { padding: 0 },
                    borderRadius: '8px !important',
                    boxShadow: 'unset',
                    bgcolor: 'background.card',
                    padding: '0px 16px',
                    width: '100%',
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      flexDirection: 'row-reverse',
                      justifyContent: 'end',
                    }}
                  >
                    <Stack
                      width={'100%'}
                      justifyContent={'end'}
                      flexDirection={'row'}
                      alignItems={'center'}
                      flexWrap={'wrap'}
                      fontWeight={'bold'}
                    >
                      <Chip
                        size="small"
                        variant="outlined"
                        label={
                          data?.items?.length > 0 &&
                          data?.items[missionNo - 1]?.parcels?.length > 0
                            ? data?.items[missionNo - 1]?.parcels[index]?.status
                            : ''
                        }
                        sx={{
                          mx: 1,
                          borderColor: 'divider',
                          color: 'text.primary',
                          fontWeight: 500,
                          fontSize: '0.75rem',
                          textTransform: 'capitalize',
                        }}
                      />{' '}
                      مرسوله شماره {index + 1} <br />
                      <Typography
                        color={'text.primary'}
                        variant="subtitle2"
                        justifyContent="flex-start"
                        textAlign={'left'}
                        width={'100%'}
                      >
                        {selectedData[index]?.hasStatus
                          ? selectedData[index]?.stringStatus
                          : ''}
                      </Typography>
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack width={'100%'}>
                      <Typography
                        color={'text.primary'}
                        variant="subtitle1"
                        justifyContent="flex-start"
                        textAlign={'left'}
                        fontWeight={'bold'}
                      >
                        گیرنده{' '}
                      </Typography>
                      <Typography
                        color={'text.primary'}
                        variant="subtitle2"
                        justifyContent="flex-start"
                        textAlign={'left'}
                        width={'100%'}
                      >
                        {item?.to?.location?.address
                          ? `${item.to.location.address} - ${
                              item?.to.contact?.first_name ?? ''
                            } ${item?.from.contact?.last_name ?? ''}`
                          : '-'}
                      </Typography>
                    </Stack>{' '}
                    <Stack
                      justifyContent={'space-between'}
                      display={'flex'}
                      flexDirection={isSmallerThan290 ? 'column' : 'row'}
                      flexWrap={'wrap-reverse'}
                    >
                      <Stack>
                        <Typography
                          color={'text.primary'}
                          variant="subtitle1"
                          justifyContent="flex-start"
                          textAlign={'left'}
                          fontWeight={'bold'}
                          mt={2}
                        >
                          وزن{' '}
                        </Typography>
                        <Typography
                          color={'text.primary'}
                          variant="subtitle2"
                          justifyContent="flex-start"
                          textAlign={'left'}
                          width={'100%'}
                        >
                          {addCommas(item?.parcel_items[0]?.weight || '-')}
                        </Typography>
                      </Stack>
                      <Stack>
                        <Typography
                          color={'text.primary'}
                          variant="subtitle1"
                          justifyContent="flex-start"
                          textAlign={'left'}
                          fontWeight={'bold'}
                          mt={2}
                        >
                          شماره مرسوله{' '}
                        </Typography>
                        <Typography
                          color={'text.primary'}
                          variant="subtitle2"
                          justifyContent="flex-start"
                          textAlign={'left'}
                          width={'100%'}
                        >
                          {item?.parcel_no || '-'}
                        </Typography>
                      </Stack>
                    </Stack>
                    <Stack
                      justifyContent={'space-between'}
                      display={'flex'}
                      flexDirection={isSmallerThan290 ? 'column' : 'row'}
                      flexWrap={'wrap-reverse'}
                    >
                      <Stack>
                        <Typography
                          color={'text.primary'}
                          variant="subtitle1"
                          justifyContent="flex-start"
                          textAlign={'left'}
                          fontWeight={'bold'}
                          mt={2}
                          width={'100%'}
                        >
                          اندازه مرسوله
                        </Typography>
                        <Typography
                          color={'text.primary'}
                          variant="subtitle2"
                          justifyContent="flex-start"
                          textAlign={'left'}
                          width={'100%'}
                        >
                          {selectedData?.[0]?.parcel_properties?.length || '-'}*
                          {selectedData?.[0]?.parcel_properties?.width || '-'}*
                          {selectedData?.[0]?.parcel_properties?.height || '-'}
                        </Typography>
                      </Stack>
                      <Stack>
                        <Typography
                          color={'text.primary'}
                          variant="subtitle1"
                          justifyContent="flex-start"
                          textAlign={'left'}
                          fontWeight={'bold'}
                          mt={2}
                          width={'100%'}
                        >
                          مایعات
                        </Typography>
                        <Typography
                          color={'text.primary'}
                          variant="subtitle2"
                          justifyContent="flex-start"
                          textAlign={'left'}
                          width={'100%'}
                        >
                          {item?.parcel_properties?.is_liquid ? 'بله' : 'خیر'}
                        </Typography>
                      </Stack>
                      <Stack>
                        <Typography
                          color={'text.primary'}
                          variant="subtitle1"
                          justifyContent="flex-start"
                          textAlign={'left'}
                          fontWeight={'bold'}
                          mt={2}
                          width={'100%'}
                        >
                          شکستنی
                        </Typography>
                        <Typography
                          color={'text.primary'}
                          variant="subtitle2"
                          justifyContent="flex-start"
                          textAlign={'left'}
                          width={'100%'}
                        >
                          {item?.parcel_properties?.is_fragile ? 'بله' : 'خیر'}
                        </Typography>
                      </Stack>
                    </Stack>
                    <Stack width={'100%'}>
                      <Typography
                        color={'text.primary'}
                        variant="subtitle1"
                        justifyContent="flex-start"
                        textAlign={'left'}
                        fontWeight={'bold'}
                        mt={2}
                        mb={2}
                      >
                        محتویات مرسوله{' '}
                      </Typography>
                      <Typography
                        color={'text.primary'}
                        variant="subtitle2"
                        justifyContent="flex-start"
                        textAlign={'left'}
                        width={'100%'}
                      >
                        {item?.parcel_items[0]?.description || '-'}
                      </Typography>
                    </Stack>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            );
          })}
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            mt={2}
          >
            <Button
              variant="outlined"
              fullWidth
              onClick={() => setOpenDetail(false)}
            >
              بستن{' '}
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default DetailModal;
